import React from "react";
import {
  DIWALI_RANGOLI_PETALS,
  DIWALI_SPARKLES,
} from "../../../utils/constants/Navbar";
import "../../../styles/diwaliTheme.css";

/** Rangoli, shimmering gold underline and twinkling sparkles behind the Diwali navbar. */
const DiwaliGlow = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <svg
        viewBox="0 0 100 100"
        className="diwali-rangoli absolute -left-6 top-1/2 h-[120px] w-[120px] -translate-y-1/2 opacity-[0.16]"
      >
        {DIWALI_RANGOLI_PETALS.map((angle) => (
          <ellipse
            key={angle}
            cx="50"
            cy="22"
            rx="7"
            ry="18"
            fill="#ea580c"
            transform={`rotate(${angle} 50 50)`}
          />
        ))}
        <circle
          cx="50"
          cy="50"
          r="14"
          fill="none"
          stroke="#f59e0b"
          strokeWidth="3"
        />
        <circle cx="50" cy="50" r="6" fill="#f59e0b" />
      </svg>
      <span className="diwali-underline absolute inset-x-0 bottom-0 h-[2px] bg-[linear-gradient(90deg,#f59e0b,#fde68a,#f97316,#fde68a,#f59e0b)] bg-[length:200%_100%]" />
      {DIWALI_SPARKLES.map((s) => (
        <svg
          key={s.left}
          viewBox="0 0 10 10"
          className="diwali-sparkle absolute"
          style={{
            left: s.left,
            top: s.top,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
          }}
        >
          <path d="M5 0L6 4L10 5L6 6L5 10L4 6L0 5L4 4Z" fill={s.color} />
        </svg>
      ))}
    </div>
  );
};

export default DiwaliGlow;
